import { useQuery } from '@tanstack/react-query';

import { axiosInstance } from '~/services';

import { API_ENDPOINT } from '~/constants';

import { deliveryAgencyKeys } from './keys';

import type {
  TypeGetDashboardDeliveryStatusParams,
  TypeGetDashboardDeliveryStatusResponse,
} from '~/types/delivery-agency.types';

/**
 * [배송 현황 대시보드] 실시간 배송 현황 조회 API
 */
const fetchDashboardDeliveryStatus = async (
  params: TypeGetDashboardDeliveryStatusParams
): Promise<TypeGetDashboardDeliveryStatusResponse> => {
  const { data } = await axiosInstance.get<TypeGetDashboardDeliveryStatusResponse>(
    API_ENDPOINT.DELIVERY_AGENCY.GET_DASHBOARD_DELIVERY_STATUS,
    { params }
  );
  return data;
};

type UseGetDashboardDeliveryStatusQueryOptions = {
  params: TypeGetDashboardDeliveryStatusParams;
  enabled?: boolean;
};

/**
 * [배송 현황 대시보드] 실시간 배송 현황 조회 Query Hook
 */
export const useGetDashboardDeliveryStatusQuery = ({
  params,
  enabled = true,
}: UseGetDashboardDeliveryStatusQueryOptions) => {
  return useQuery({
    queryKey: deliveryAgencyKeys.dashboardDeliveryStatus(params),
    queryFn: () => fetchDashboardDeliveryStatus(params),
    enabled,
    staleTime: 0,
    gcTime: 1000 * 30,
  });
};
